import { arrayOf, bool, number, oneOfType, shape, string } from "prop-types";

export const locations = arrayOf(
  shape({
    group: string,
    id: number.isRequired,
    name: string.isRequired
  })
);

export const recentSearchProps = shape({
  areas: arrayOf(
    shape({
      mapCoordinates: shape({
        centerLat: string,
        centerLon: string,
        encodedBoundary: string
      }),
      staticMapUrl: string
    })
  ),
  titleForSearch: string.isRequired,
  id: string.isRequired,
  isSaved: bool.isRequired,
  title: string.isRequired,
  label: string,
  url: string.isRequired
});

export const recentSearchesProps = arrayOf(recentSearchProps);

export const recentlyViewedListingsProps = arrayOf(
  shape({
    area: shape({
      name: string.isRequired
    }),
    bathrooms: number.isRequired,
    bedrooms: number.isRequired,
    id: string.isRequired,
    listedPrice: number.isRequired,
    mediumImageUri: string.isRequired,
    titleWithUnit: string.isRequired,
    unitTypeLabel: string.isRequired,
    url: string.isRequired
  })
);

export const recentlyViewedListingProps = shape({
  area: shape({
    name: string.isRequired
  }),
  bathrooms: number.isRequired,
  bedrooms: number.isRequired,
  id: string.isRequired,
  listedPrice: number.isRequired,
  mediumImageUri: string.isRequired,
  titleWithUnit: string.isRequired,
  unitTypeLabel: string.isRequired,
  url: string.isRequired
});

export const profile = shape({
  buySellMoveDate: string,
  rentalMoveInDate: string,
  searchType: string
});

export const user = shape({
  id: oneOfType([number, string]),
  profile
});

const contactPropType = shape({
  id: oneOfType([number, string]),
  business_url: string,
  business_name: string,
  full_business_address: string
});

export const listingPropType = shape({
  __typename: string,
  address: shape({
    pretty_address: string,
    unit: string
  }),
  area: shape({
    name: string
  }),
  bathrooms: oneOfType([number, string]),
  bedrooms: oneOfType([number, string]),
  contacts: arrayOf(contactPropType),
  id: oneOfType([number, string]),
  imgSrc: string,
  is_saved: bool,
  price: oneOfType([number, string]),
  url: string
});

const recommendedListingPropType = shape({
  listing: listingPropType,
  tracking_id: string,
  was_helpful: bool
});

export const agentMatchItemPropType = shape({
  brokerage: string.isRequired,
  brokerageAddress: string.isRequired,
  contactId: number.isRequired,
  hasSoldInBuilding: bool.isRequired,
  homesSoldNearby: number.isRequired,
  homesSoldRecent: number.isRequired,
  homesSoldSimilar: number.isRequired,
  isPro: bool.isRequired,
  licenseType: string.isRequired,
  medianSalesPrice: string.isRequired,
  name: string.isRequired,
  photoUrl: string.isRequired,
  uuid: string.isRequired,
  yearsExperience: number.isRequired
});

export const recommendedListingsPropType = arrayOf(recommendedListingPropType);
